module.exports = __webpack_public_path__ + "media/images/pages/ic-linkedin-5afaf16454e1021c989bc03ba9c91923.png";